export default class LocalStore {
    constructor( core ) {
        this.core = core
    }

    Set( name, value ) {
        return window.localStorage.setItem( name, value )
    }

    Get( name, def_value ) {
        const value = window.localStorage.getItem( name )

        if( value === undefined )
        {
            return def_value
        }

        return value
    }
}